/* @flow */

import * as React from 'react';
import ReactTooltip from 'react-tooltip';

import {colors} from '../colors';
import {DynamicButtonContent} from '../dynamic-button-content';
import {NotetakerIcon, StopIcon, LoadingIcon} from '../icon';

import {AnimatingBars} from './animating-bars';

import './transcribe-button.module.css';

type Props = {|
    getRef: (ref: ?HTMLButtonElement) => void,
    isTranscribing: boolean,
    isLoading: boolean,
    onClick: (e: SyntheticEvent<*>) => void,
|};

export function TranscribeButton(props: Props) {
    React.useEffect(() => {
        ReactTooltip.rebuild();

        const handleScroll = () => ReactTooltip.hide();
        window.addEventListener('scroll', handleScroll, true);

        return () => {
            ReactTooltip.hide();
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [props.isTranscribing, props.isLoading]);

    const buttonRef = React.useRef(null);

    const StartButtonContent = () => (
        <NotetakerIcon
            size={22}
            onClick={(e) => {
                e.preventDefault();
                props.onClick(e);
            }}
            onMouseDown={(e) => {
                e.preventDefault();
            }}
            fill={colors.plum}
            wrapWithDiv={false}
        />
    );

    const StopButtonContent = () => (
        <>
            <NotetakerIcon size={22} fill={colors.plum} wrapWithDiv={false} />
            <AnimatingBars />
            <StopIcon size={16} fill={colors.rose} color={colors.rose} wrapWithDiv={false} />
        </>
    );

    return props.isTranscribing ? (
        <div styleName='button-container'>
            <button
                styleName='stop-button'
                ref={(ref) => {
                    buttonRef.current = ref;
                    props.getRef(ref);
                }}
                data-tip='Stop taking notes'
                onClick={(e) => {
                    e.preventDefault();
                    props.onClick(e);
                }}
                onMouseDown={(e) => {
                    e.preventDefault();
                }}
            >
                <DynamicButtonContent
                    buttonRef={buttonRef}
                    defaultContent={<StopButtonContent />}
                    hoverContent={<StopButtonContent />}
                />
            </button>
        </div>
    ) : (
        <div styleName='button-container'>
            {props.isLoading ? (
                <LoadingIcon size={20} fill={colors.plum} wrapWithDiv={false} />
            ) : (
                <button
                    styleName='start-button'
                    ref={(ref) => {
                        buttonRef.current = ref;
                        props.getRef(ref);
                    }}
                    data-tip='Start taking notes'
                    onClick={(e) => {
                        e.preventDefault();
                        props.onClick(e);
                    }}
                    onMouseDown={(e) => {
                        e.preventDefault();
                    }}
                >
                    <DynamicButtonContent
                        buttonRef={buttonRef}
                        defaultContent={<StartButtonContent />}
                        hoverContent={<StartButtonContent />}
                    />
                </button>
            )}
        </div>
    );
}
